import { QbBusiness } from '../../utils/business/qbbusiness'
import { BusinessResponseHandler } from '../BusinessResponseHandler'
import {
	changePlayqueue,
	completePlayqueue
} from '../../components/miniPlayer/AudioPlayer/playerActions'
import constant from '../../constant/appConst'
import { ORIGIN_PLAYQUEUE_TYPES } from '../../components/miniPlayer/AudioPlayer/playerConstants'

module.exports = class AlbumController {

	static fetchAlbumData(albumId, offset, limit, extra, display404 = true) {
		return QbBusiness.getAlbum(albumId, offset, limit, extra, display404)
			.then(response => BusinessResponseHandler.handleResponse(response))
			.catch(error => {
				throw error
			})
	}

	static fetchSimilarAlbum(genreId, type, offset, limit) {
		return QbBusiness.getSimilarAlbum(genreId, type, offset, limit)
			.then(response => BusinessResponseHandler.handleResponse(response))
			.catch(error => {
				throw error
			})
	}

	static fetchAlbumArticles(albumId, offset, limit) {
		return QbBusiness.getAlbumArticles(albumId, offset, limit)
			.then(response => BusinessResponseHandler.handleResponse(response))
			.then((r) => {
				if (r && !r.code) {
					for (let i = 0; i < r.items.length; i++) {
						r.items[i].id = (r.items[i].id).replace('s', '')
					}
				}
				return r
			})
			.catch(error => {
				throw error
			})
	}


	/**
	 *  Lancer la lecture d'un album entier
	 */
	static playAlbum(albumdata) {
		if (albumdata) {
			let iteration = 0
			const promises = []
			let offset = constant.firstPlayLoad
			const limitFixed = constant.playLoadStep
			promises.push(AlbumController.fetchAlbumData(albumdata.id, 0, constant.firstPlayLoad))
			for (let i = 1; i <= Math.ceil(albumdata.track_count / limitFixed); i++) {
				promises.push(AlbumController.fetchAlbumData(albumdata.id, offset, limitFixed))
				offset += limitFixed
			}

			promises.push(Promise.resolve())
			promises.reduce((prev, current) => (
				prev.then((album) => {
					if (album && album.tracks.items.length > 0) {
						const albumtracks = []
						const albumdatainfo = {
							id: album.id,
							title: album.title,
							image: album.image,
							artist: album.artist,
							goodies: album.goodies ? album.goodies : null,
							description: album.description,
							track_count: album.track_count,
							media_count: album.media_count,
							genres_list: album.genres_list,
							duration: album.duration,
							label: album.label,
							release_date_original: album.release_date_original,
							genre: album.genre,
							streaming: album.streaming
						}
						let i = 0
						album.tracks.items.forEach((v) => {
							albumtracks[i] = v
							albumtracks[i].album = albumdatainfo
							i++
						})
						if (iteration === 0) {
							QbBusiness.reduxDispatch(changePlayqueue(albumtracks, ORIGIN_PLAYQUEUE_TYPES.album, albumdatainfo.id))
						} else {
							QbBusiness.reduxDispatch(completePlayqueue(albumtracks, ORIGIN_PLAYQUEUE_TYPES.album, albumdatainfo.id))
						}
						iteration++
					}
					return current
				})
			), Promise.resolve())
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/controllers/AlbumController.js